import React from 'react';
import { frameworkStages } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
export function Framework() {
  return <section className="bg-navy py-16 sm:py-24" data-id="element-175" data-mp="17q9qcqbz3ae4">
      <div className="mx-auto max-w-6xl px-4" data-id="element-176" data-mp="17oymkqij22n0">
        <SectionHeading tone="dark" eyebrow="The Framework" title="The Third Molar Master Clinical Map™" intro="One visual framework. Six connected stages. A clearer way to organize your third molar assessment." data-id="element-177" data-mp="12roybe6vjx0r" />

        <ol className="relative mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-178" data-mp="szixrg2k479y">
          {frameworkStages.map((stage, i) => <li key={stage.title} className="flex gap-4 rounded-2xl bg-white/[0.06] p-5 ring-1 ring-inset ring-white/10 sm:p-6" data-id="element-179" data-mp="k179vlt2rnl7" data-mpi={i}>
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-sky font-display text-xl font-bold text-navy" data-id="element-180" data-mp="f0szhx4041k0">
                {i + 1}
              </span>
              <div data-id="element-181" data-mp="1e3efk07s9yhi">
                <h3 className="text-lg font-extrabold uppercase tracking-wide text-white" data-id="element-182" data-mp="1e2v6l9042kfm">{stage.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-white/75" data-id="element-183" data-mp="1ivg0eaj0oxj5">{stage.text}</p>
              </div>
            </li>)}
        </ol>

        <div className="mx-auto mt-10 max-w-3xl space-y-3 text-center text-[15px] leading-relaxed text-white/80" data-id="element-184" data-mp="1a22ywk6w0nlg">
          <p className="text-lg font-semibold text-white" data-id="element-185" data-mp="1xrdp57qm2zlc">
            The purpose of this framework is to make your assessment process more organized and repeatable.
          </p>
          <p data-id="element-186" data-mp="1ntzoagh68je5">
            It does not automatically determine whether a third molar should be removed, predict surgical outcomes, or replace a
            comprehensive clinical and radiographic evaluation.
          </p>
        </div>

        <div className="mt-10" data-id="element-187" data-mp="cdj1u37792hs">
          <CtaButton tone="dark" label="Get the Complete Third Molar Blueprint™" sub="Instant digital access · One-time payment · 7-day guarantee" data-id="element-188" data-mp="cgng5tedpem6" />
        </div>
      </div>
    </section>;
}